var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronsRight = function SvgChevronsRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.956 12.094a.62.62 0 0 1-.08.781l-7.814 7.816a.622.622 0 0 1-.88-.88l7.377-7.375L2.183 5.06a.622.622 0 0 1 .879-.88l7.815 7.816zm10.942 0a.62.62 0 0 1-.08.781l-7.815 7.816a.622.622 0 0 1-.879-.88l7.376-7.375-7.376-7.376a.622.622 0 0 1 .879-.88l7.815 7.816z"
  })));
};
export default SvgChevronsRight;